/**
 * Returns the API prefix for file uploads based on storage directory.
 * Files go through v2 (directly to file_server_ex), images and assets stay on v1.
 */
export default function storageUploadPrefix(storageDirectory: string): string {
  return storageDirectory === "files" ? "/api/storage/v2" : "/api/storage";
}
